import React from 'react';

import { DIGITAL_BUDGET_WARNING_RATE } from '../../../constants/shell';
import { IUser } from '../../../types/users';
import { getUserRoleLabel } from '../../../utils/users';
import { Avatar, Budget, Card } from '../../index';

import styles from './GridView.module.scss';

interface IProps {
  users: IUser[];
  getDepartmentLabel: (id: string) => string | undefined;
  handleUserClick: (user: IUser) => void;
  renderIntegrations: (_: Partial<IUser>) => React.ReactNode;
  checkCanEditUser: (user: IUser) => boolean;
  renderControls: (user: IUser) => React.ReactNode;
  renderSkipCrmCheckbox: (user: IUser) => React.ReactNode;
}

const GridView = ({
  users,
  getDepartmentLabel,
  handleUserClick,
  renderIntegrations,
  checkCanEditUser,
  renderControls,
  renderSkipCrmCheckbox,
}: IProps) => {
  return (
    <div className={styles.list}>
      {users.map((user: IUser) => {
        const {
          uid,
          first_name,
          last_name,
          email,
          picture,
          used_budget,
          available_budget,
          budget_currency,
          admin_type,
          department_id,
          integration,
        } = user;
        return (
          <Card
            className={styles.card}
            key={uid}
            onClick={() => handleUserClick(user)}
            top={
              <React.Fragment>
                <Avatar className={styles.avatar} image={picture} />
                <div className={styles.userInfo}>
                  <span className={styles.username}>
                    {first_name} {last_name}
                  </span>
                  <span className={styles.email}>{email}</span>
                </div>
                <div className={styles.roleDeptInfo}>
                  <span className={styles.department}>{getDepartmentLabel(department_id)}</span>
                  <span className={styles.role}>{getUserRoleLabel(admin_type)}</span>
                </div>
              </React.Fragment>
            }
            middle={
              <React.Fragment>
                {renderIntegrations({ integration, uid })}
                <Budget
                  className={styles.budget}
                  usedBudget={used_budget}
                  availableBudget={available_budget}
                  fixedDecimalScale={false}
                  lowBudgetRate={DIGITAL_BUDGET_WARNING_RATE}
                  budgetCurrency={budget_currency}
                />
              </React.Fragment>
            }
            bottom={checkCanEditUser(user) ? renderControls(user) : renderSkipCrmCheckbox(user)}
            topClassName={styles.top}
            middleClassName={styles.middle}
            bottomClassName={styles.controls}
          />
        );
      })}
    </div>
  );
};

export default GridView;
